import React from "react";
import { useChangeBackground } from "../hooks/useChangeBackground";
import useVerifyMenu from "../hooks/useVerifyMenu";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import AdminMui from "../components/Masters/AdminMui";
import { useChangeTitleAppBar } from "../hooks/useChangeTitleAppBar";
import { CreateMark, ListMarks, UpdateMark } from "../utils/Marks";
import Swal from "sweetalert2";
import { MarkTable } from "../components/Organisms/Mark/MarkTable/Index";
import { EditMark } from "../components/Organisms/Mark/EditMark";

export const Marks = () => {
  const back = useVerifyMenu();
  const history = useHistory();
  const [marks, setMarks] = React.useState([]);
  const [againFetch, setAgainFetch] = React.useState(false);
  const [showModal, setShowMondal] = React.useState({
    show: false,
    data: {},
  });

  useChangeBackground("#f5f5f8");
  useChangeTitleAppBar("Marcas");

  React.useEffect(() => {
    ListMarks()
      .then((res) => setMarks(res.data))
      .catch((err) =>
        Swal.fire({
          title: "Error!",
          text: err.message || "",
          icon: "error",
          confirmButtonText: "Ok",
        })
      );
  }, [againFetch]);

  const ApiDeleteMark = (mark) => {
    return UpdateMark(mark);
  };

  const handleClick = (mark) => {
    if (!mark.id) {
      CreateMark(mark)
        .then((res) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Proceso Ejecutado exitosamente!",
            text: res.message || "",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(() => setAgainFetch(!againFetch));
        })
        .catch((err) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Error!",
            text: err || "",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    } else {
      UpdateMark(mark)
        .then((res) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Proceso Ejecutado exitosamente!",
            text: res.message || "",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(() => setAgainFetch(!againFetch));
        })
        .catch((err) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Error!",
            text: err.message || "",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    }
  };

  return !back ? (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Configuración de marcas - Supre</title>
        <meta name="description" content="marcas admin supre" />
      </Helmet>
      <AdminMui>
        <MarkTable
          setShowMondal={setShowMondal}
          marks={marks}
          setAgainFetch={setAgainFetch}
          againFetch={againFetch}
          ApiDeleteMark={ApiDeleteMark}
        />
        {showModal.show && (
          <EditMark
            showModal={showModal}
            setShowMondal={setShowMondal}
            handleClick={handleClick}
          />
        )}
      </AdminMui>
    </>
  ) : (
    <>{history.push("/admin/login")}</>
  );
};
